export default "/assets/images/purely-white.173cf90bfe812742.jpg";